export function moveListItem(items, fromIndex, toIndex) {
  if (
    fromIndex === toIndex
    || fromIndex < 0
    || fromIndex >= items.length
    || toIndex < 0
    || toIndex >= items.length
  ) {
    return items;
  }

  const reordered = [...items];
  const [moved] = reordered.splice(fromIndex, 1);
  reordered.splice(toIndex, 0, moved);
  return reordered;
}
